import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as NavLogo } from '../../home-redesign/assets/nav-logo.svg';
import HomeRedesignNavRating from '../../home-redesign/HomeRedesignNavRating';
import PartnersCtaButton from '../components/PartnersCtaButton';
import { usePartnersStrings } from '../usePartnersStrings';

const PartnersNav: React.FC = () => {
  const s = usePartnersStrings();

  return (
    <header className="sticky top-0 z-50 overflow-visible border-b border-[rgba(74,33,71,0.1)] bg-[rgba(252,247,250,0.85)] backdrop-blur-[5px]">
      <nav className="mx-auto grid w-full max-w-[1440px] grid-cols-[1fr_auto_1fr] items-center gap-2 overflow-visible px-5 pb-[13px] pt-[max(0.75rem,env(safe-area-inset-top))] sm:px-8 hero:gap-4 hero:px-[80px] hero:pb-[23px] hero:pt-[max(1.375rem,env(safe-area-inset-top))]">
        <Link
          to="/"
          className="relative shrink-0 justify-self-start text-chisme-primary hero:w-[120px]"
          aria-label={s.nav.logoAria}
        >
          <NavLogo
            aria-hidden
            className="block h-7 w-[89px] max-w-none hero:h-[37px] hero:w-[120px]"
          />
        </Link>

        <HomeRedesignNavRating />

        <div className="flex shrink-0 items-center justify-end justify-self-end">
          <PartnersCtaButton
            className="!min-h-[39px] !px-4 !py-[11px] !text-[13.5px] sm:!px-[18px]"
            arrowClassName="hidden sm:block"
          >
            <span className="sm:hidden">{s.nav.ctaShort}</span>
            <span className="hidden sm:inline">{s.nav.ctaLong}</span>
          </PartnersCtaButton>
        </div>
      </nav>
    </header>
  );
};

export default PartnersNav;
